export default function ({app, error}) {
  if (!app.$planHasPermission('view_works')) {
    return error({
      message: '権限がありません。',
      redirectPath: app.$redirectPathDefault(),
      redirectText: 'メインメニュー'
    });
  }
}